var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C16.7689 28 19.4757 27.1789 21.778 25.6406C24.0803 24.1022 25.8747 21.9157 26.9343 19.3576C27.9939 16.7994 28.2712 13.9845 27.731 11.2687C27.1908 8.553 25.8574 6.05844 23.8995 4.10051C21.9415 2.14258 19.447 0.809205 16.7313 0.269012C14.0155 -0.271181 11.2006 0.00606603 8.64243 1.06569C6.08426 2.12532 3.89776 3.91973 2.35942 6.22202C0.821085 8.52431 0 11.2311 0 14C0 17.713 1.475 21.274 4.1005 23.8995C6.72601 26.525 10.287 28 14 28ZM6.73272 14.3691C6.97119 14.132 7.29376 13.999 7.63 13.999C7.96623 13.999 8.28881 14.132 8.52727 14.3691L11.4545 17.2964L18.8236 9.92727C19.0671 9.71877 19.3803 9.60981 19.7006 9.62219C20.0209 9.63456 20.3248 9.76735 20.5514 9.99401C20.7781 10.2207 20.9109 10.5245 20.9233 10.8448C20.9356 11.1652 20.8267 11.4783 20.6182 11.7218L12.3454 19.9945C12.107 20.2316 11.7844 20.3646 11.4482 20.3646C11.1119 20.3646 10.7894 20.2316 10.5509 19.9945L6.73272 16.1764C6.61343 16.058 6.51875 15.9173 6.45414 15.7622C6.38952 15.6071 6.35625 15.4407 6.35625 15.2727C6.35625 15.1047 6.38952 14.9384 6.45414 14.7833C6.51875 14.6282 6.61343 14.4874 6.73272 14.3691Z",
    fill: "#BF202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTick);
export default __webpack_public_path__ + "static/media/iconTick.0caec756a3f17c23253cb64c95c8795a.svg";
export { ForwardRef as ReactComponent };